import React from 'react';
import { ToggleButton, ToggleButtonProps, useTheme } from '@mui/material';
import Color from 'color';

export const choiceGroupSx = { gap: 1.5 };

export const OrderPageChoiceButton = ({ icon, children, ...props }: ToggleButtonProps & { icon?: React.ReactNode }) => {
  const theme = useTheme();
  const { palette } = theme.customTheme;
  const selectedBackground = Color(palette.primary).alpha(0.125).string();

  return (
    <ToggleButton
      sx={{
        minHeight: icon ? 56 : 44,
        flex: 1,
        gap: 1,
        textTransform: 'none',
        fontSize: 16,
        color: palette.text.primary,
        backgroundColor: palette.background,
        // Raised specificity: ToggleButtonGroup's grouped rules would otherwise join the tiles into one bar.
        '&&&': { margin: 0, borderRadius: '8px', border: `1px solid ${palette.border}` },
        '&&&:hover': { borderColor: palette.primary, backgroundColor: palette.background },
        '&&&.Mui-selected': {
          border: `3px solid ${palette.primary}`,
          backgroundColor: selectedBackground,
          fontWeight: 600,
        },
        '& svg': { fontSize: 20 },
      }}
      {...props}>
      {icon}
      {children}
    </ToggleButton>
  );
};
